module.exports = __webpack_public_path__ + "42490ca1aac1a7229137912f39ad3385.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/asscher.png
// module id = 754
// module chunks = 0